import axios from '../shared/axios';
// import qs from 'querystring';
import store from "../store/store";
import * as contractDuck from "../store/ducks/contract.duck";
import * as actionsDuck from "../store/ducks/actions.duck";

// export function create(data) {
//     return new Promise(async (resolve, reject) => {
//         try {
//             const result = await axios.post(`/api/Action/Create`, data);
//             store.dispatch({ type: contractDuck.actionTypes.CONTRACT_REFRESH_DASHBOARD });
//             store.dispatch({ type: actionsDuck.actionTypes.ACTIONS_SET_PENDING });
//             resolve(result);
//         }
//         catch (err) {
//             reject(err)
//         }
//     });
// }

// export function update(data) {
//     return new Promise(async (resolve, reject) => {
//         try {
//             const result = await axios.put(`/api/Action/Update`, data);
//             store.dispatch({ type: contractDuck.actionTypes.CONTRACT_REFRESH_DASHBOARD });
//             store.dispatch({ type: actionsDuck.actionTypes.ACTIONS_SET_PENDING });
//             resolve(result);
//         }
//         catch (err) {
//             reject(err)
//         }
//     });
// }

// export function importActions(data) {
//     return new Promise(async (resolve, reject) => {
//         try {
//             const result = await axios.post(`/api/Action/Import`, data);
//             store.dispatch({ type: contractDuck.actionTypes.CONTRACT_REFRESH_DASHBOARD });
//             store.dispatch({ type: actionsDuck.actionTypes.ACTIONS_SET_PENDING });
//             resolve(result);
//         }
//         catch (err) {
//             reject(err)
//         }
//     });
// }

// export function complete(data) {
//     return new Promise(async (resolve, reject) => {
//         try {
//             const result = await axios.put(`/api/Action/Complete`, data);
//             store.dispatch({ type: contractDuck.actionTypes.CONTRACT_REFRESH_DASHBOARD });
//             store.dispatch({ type: actionsDuck.actionTypes.ACTIONS_SET_PENDING });
//             resolve(result);
//         }
//         catch (err) {
//             reject(err)
//         }
//     });
// }
// export function deleteAction(data) {
//     return new Promise(async (resolve, reject) => {
//         try {
//             const result = await axios.delete(`/api/Action/Delete`, { data: data });
//             store.dispatch({ type: contractDuck.actionTypes.CONTRACT_REFRESH_DASHBOARD });
//             store.dispatch({ type: actionsDuck.actionTypes.ACTIONS_SET_PENDING });
//             resolve(result);
//         }
//         catch (err) {
//             reject(err)
//         }
//     });
// }

// export function getRegisterList(contractid, includecompleted, includearchived, includedeleted, accessibleWfIds) {
//     return axios.post(`/api/Action/RegisterList`, { accessibleWfIds }, { params: { contractid, includecompleted, includearchived, includedeleted } });
// }

// export function getPendingActions(contractid, accessibleWfIds) {
//     return axios.post(`/api/Action/GetPendingActions`, { accessibleWfIds }, { params: { contractid } });
// }

// export function loadClearActionOptions(contractid, workflowid, recordid, actionTypes) {
//     return axios.post(`/api/Action/LoadClearActionOptions`, actionTypes, { params: { contractid, workflowid, recordid } });
//     // return axios.post(`/api/Tag/GetTagsForCategory`,categories, { params: { companyid } });

// }

// export function regenerateSystemActions(contractid) {
//     return new Promise(async (resolve, reject) => {
//         try {
//             const result = await axios.patch(`/api/Action/RegenerateSystemActions`, null, { params: { contractid } });
//             store.dispatch({ type: contractDuck.actionTypes.CONTRACT_REFRESH_DASHBOARD });
//             store.dispatch({ type: actionsDuck.actionTypes.ACTIONS_SET_PENDING });
//             resolve(result);
//         }
//         catch (err) {
//             reject(err)
//         }
//     });
// }

// export function getContractPendingDrafts(contractid, accessibleWfIds) {
//     return axios.post(`/api/Action/GetPendingDrafts`, { accessibleWfIds }, { params: { contractid } });
// }

export function getSettings() {
    return axios.get(`/api/Settings/GetSettings`, { params: { isMiddleware:false } });
}

export function getSettingsRegisterList() {
    return axios.get(`/api/Settings/GetSettings_RegisterList`, { params: { isMiddleware:false } });
}
export function getSettingsApplied(companyid, contractid) {
    return axios.get(`/api/Settings/GetSettings_Applied`, { params: { companyid, contractid } });
}

export function deleteSetting(settingsid) {
    return axios.delete(`/api/Settings/RemoveSetting`, { params: { settingsid } });
}
export function getSettingPatterns() {
    return axios.get(`/api/Settings/GetPatterns`);
}
export function getSettingPattern(settingspatternid) {
    return axios.get(`/api/Settings/GetPattern`, { params: { settingspatternid } });
}
export function saveSetting(data) {
    return axios.post(`/api/Settings/Save`, data);
}

export function updateSetting(data) {
    return axios.put(`/api/Settings/Update`, data);
}

// export function getNextPaymentActionsSummary(contractid) {
//     return axios.get(`/api/Action/GetNextPaymentActionsSummary`, { params: { contractid } });
// }